/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'image-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M14 2l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h8m4 18V9h-5V4H6v16h12m-1-7v6H7l5-5 2 2m-4-5.5A1.5 1.5 0 018.5 12 1.5 1.5 0 017 10.5 1.5 1.5 0 018.5 9a1.5 1.5 0 011.5 1.5z"/>'
  }
})
